export default (ctx, inject) => {
  const formatPrice = function (
    priceInc,
    minimumFractionDigits = 2,
    currency = 'rub', // для последующей мультиязычности
    lang = ctx.app.i18n.locale) {
    const price = Number(priceInc)

    if (typeof price !== 'number') throw new Error('Not number')

    if (lang === 'ru') {
      return price.toLocaleString('ru-RU', {
        style: 'currency',
        currencyDisplay: 'symbol',
        currency: 'RUB',
        minimumFractionDigits
      })
    } else if (lang === 'en') {
      return price.toLocaleString('en-US', {
        style: 'currency',
        currencyDisplay: 'symbol',
        currency: 'RUB',
        minimumFractionDigits
      }).replace('RUB', '₽')
    }
  }

  ctx.$priceFormatter = formatPrice
  inject('priceFormatter', formatPrice)
}